export default __webpack_public_path__ + "static/media/engineer.3b8bc3d9.jpg";